/**
 * Drawer styled to match the Traton-blue app chrome (same primary background and white text as the
 * header menubar). Without this, PrimeNG renders the drawer on the default white surface, which
 * looks out of place against the dark header. Mirrors the drawerHeaderDesignToken the other Test
 * Tools apps get from @tmt/traton-theme.
 */
export const drawerHeaderDesignToken = {
	background: '{primary.950}',
	color: 'white',
	border: {
		radius: '0',
		color: '{primary.900}',
	}
};
